import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=1171266d&scoped=true&"
import script from "./GoodsInfo.vue?vue&type=script&lang=js&"
export * from "./GoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=1171266d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171266d",
  null
  
)

export default component.exports